import {
    ArrowsRightLeftIcon,
    CalculatorIcon,
    CubeIcon,
    DocumentTextIcon,
    LinkIcon,
} from "@heroicons/react/24/outline";
import type {PresentationSourceType} from "../../../../../generated/enums.ts";

const badgeConfig: Record<PresentationSourceType, {label: string; icon: typeof DocumentTextIcon}> = {
    BILL: {label: "Factuur", icon: DocumentTextIcon},
    TRANSACTION: {label: "Transactie", icon: ArrowsRightLeftIcon},
    MANUAL_BOOKING: {label: "Memoriaal", icon: CalculatorIcon},
    FIXED_ASSET: {label: "Vast actief", icon: CubeIcon},
    MATCH: {label: "Betaling", icon: LinkIcon},
};

export function sourceTypeLabel(kind: PresentationSourceType): string {
    return badgeConfig[kind].label;
}

export function TypeBadge({
    kind,
    fileName = null,
}: {
    kind: PresentationSourceType | null;
    fileName?: string | null;
}) {
    const config = kind === null
        ? {label: "Onbekend", icon: DocumentTextIcon}
        : badgeConfig[kind];
    const Icon = config.icon;
    return (
        <span
            title={fileName ?? undefined}
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-muted px-2.5 py-1 text-xs font-medium text-gray-800 ring-1 ring-inset ring-border"
        >
            <Icon className="size-3.5 shrink-0" aria-hidden />
            {config.label}
        </span>
    );
}
